/**
 * SPY-209: ARAM shop filter / search stub (domain).
 */

import { isBootsItem } from './bootsMsFidelity.js';

export const ARAM_SHOP_CATEGORIES = Object.freeze([
  'all', 'consumable', 'boots', 'attack', 'defense', 'magic', 'utility', 'legendary', 'mythic'
]);

export function normalizeShopQuery(query) {
  if (query === null || query === undefined) return '';
  return String(query).trim().toLowerCase();
}

export function itemMatchesShopQuery(item, query) {
  const q = normalizeShopQuery(query);
  if (!q || !item) return true;
  const hay = [item.id, item.name, item.description]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return hay.includes(q);
}

export function itemShopCategory(item) {
  if (!item) return 'all';
  if (item.isConsumable) return 'consumable';
  if (item.isUtility || item.isWard) return 'utility';
  if (isBootsItem(item.id)) return 'boots';
  if (item.isMythic) return 'mythic';
  if (item.isLegendary || (item.cost >= 3000 && Array.isArray(item.components) && item.components.length > 0)) {
    return 'legendary';
  }
  const stats = item.stats || {};
  if (stats.ad || stats.as || stats.critChance) return 'attack';
  if (stats.ap || stats.mp) return 'magic';
  if (stats.armor || stats.mr || stats.maxHp) return 'defense';
  return 'all';
}

export function itemMatchesShopCategory(item, category = 'all') {
  if (!category || category === 'all') return true;
  return itemShopCategory(item) === category;
}

/**
 * @param {Record<string, object>} catalog
 * @param {string} [query]
 * @param {string} [category]
 * @returns {Record<string, object>}
 */
export function filterAramShopCatalog(catalog, query = '', category = 'all') {
  const q = normalizeShopQuery(query);
  const out = {};
  for (const [id, item] of Object.entries(catalog || {})) {
    if (!itemMatchesShopQuery(item, q)) continue;
    if (!itemMatchesShopCategory(item, category)) continue;
    out[id] = item;
  }
  return out;
}
